import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import ServicesOverviewPage from './pages/ServicesOverviewPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import GenericPage from './pages/GenericPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

function ServiceRouteAlias() {
  const { slug } = useParams();
  return <ServiceDetailPage key={slug} slug={slug} />;
}

function DirectServiceAlias({ slug }) {
  return <ServiceDetailPage key={slug} slug={slug} />;
}

function DirectGenericAlias({ slug }) {
  return <GenericPage key={slug} />;
}

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-white text-slate-900 font-sans selection:bg-sky-100 selection:text-sky-900 antialiased">
        <Header />
        <main className="flex-1">
          <Routes>
            {/* Primary Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/ydelser" element={<ServicesOverviewPage />} />
            <Route path="/ydelser/:slug" element={<ServiceRouteAlias />} />
            
            {/* Scraped direct URL aliases for services */}
            <Route path="/rengoering-privat" element={<DirectServiceAlias slug="rengoering-privat" />} />
            <Route path="/rengoering-erhverv" element={<DirectServiceAlias slug="rengoering-erhverv" />} />
            <Route path="/snerydning" element={<DirectServiceAlias slug="snerydning" />} />
            <Route path="/haveservice" element={<DirectServiceAlias slug="haveservice" />} />
            <Route path="/vinduespolering" element={<DirectServiceAlias slug="vinduespolering" />} />
            <Route path="/maatteservice" element={<DirectServiceAlias slug="maatteservice" />} />
            <Route path="/tagrenderensning" element={<DirectServiceAlias slug="tagrenderensning" />} />

            {/* Company & Contact */}
            <Route path="/hvem-er-vi" element={<AboutPage />} />
            <Route path="/kontakt" element={<ContactPage />} />

            {/* Scraped category pages */}
            <Route path="/category-projekt" element={<DirectGenericAlias slug="category-projekt" />} />
            <Route path="/category-bokse" element={<DirectGenericAlias slug="category-bokse" />} />
            <Route path="/side/:slug" element={<GenericPage />} />

            {/* Error Pages */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
